import { DataSubSideBar } from 'components/types/parts/sidebar';
import { Hooks } from 'providers';
import { useContext } from 'react';
import { Link } from 'react-router-dom';

function TooltipCustom({
  data, style, children, className,
}: DataSubSideBar) {
  const { sideBar } = useContext(Hooks);

  return (
    <div className={`${className || 'tooltipCustom'} `}>
      {children}
      <div className="tooltipTextCustom" style={style}>
        {data?.map((item) => (
          <Link
            key={item.id}
            style={{ padding: '5px 0px', color: '#495057' }}
            to={{
              pathname: item.value,
              search: item.search || '',
              state: { sideBarHide: !sideBar },
            }}
          >
            {item.name}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default TooltipCustom;
